import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/pages/CierreMensual.css';
import { API_BASE_URL } from '../config';
import { confirmarCierreMes } from '../utils/alerts';

const meses = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
];

const CierreMensual = ({ token, id_company }) => {
  const currentYear = new Date().getFullYear();
  const [anio, setAnio] = useState(currentYear);
  const [estado, setEstado] = useState({});
  const [procesando, setProcesando] = useState(false);
  const [mensajeProcesando, setMensajeProcesando] = useState('');
  const fetchEstado = async (year) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/cierre-mensual`, {
        params: { company: id_company, anio: year },
        headers: { Authorization: `Bearer ${token}` }
      });
      const map = {};
      res.data.forEach((r) => { map[r.mes] = r.cerrado; });
      setEstado(map);
    } catch (err) {
      console.error('Error al obtener cierre mensual:', err);
    }
  };
  useEffect(() => {
    if (id_company) fetchEstado(anio);
  }, [anio, id_company]);
  const toggleMes = async (mes) => {
    if (procesando) return; // evita doble clic mientras ya hay un proceso en curso
    const cerrado = !estado[mes];
    // Cerrar fija la propuesta del F29: se pide confirmar que todo está cargado. Reabrir no pregunta.
    if (cerrado && !(await confirmarCierreMes(meses[mes - 1], anio))) return;
    setMensajeProcesando(
      cerrado
        ? `Cerrando ${meses[mes - 1]} ${anio}... esto puede tardar unos segundos.`
        : `Reabriendo ${meses[mes - 1]} ${anio}...`
    );
    setProcesando(true);
    try {
      await axios.post(`${API_BASE_URL}/api/cierre-mensual`, {
        company: id_company,
        anio,
        mes,
        cerrado
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEstado({ ...estado, [mes]: cerrado });
    } catch (err) {
      console.error('Error al actualizar cierre mensual:', err);
      // Mostrar mensaje de error al usuario
      if (err.response && err.response.data) {
        const errorMsg = err.response.data.message || err.response.data.error || 'Error al actualizar cierre mensual';
        alert(errorMsg);
      } else {
        alert('Error al actualizar cierre mensual');
      }
      // Si falló el cierre, el backend revirtió todo: refrescamos el estado real
      // en vez de asumir que quedó cerrado.
      fetchEstado(anio);
    } finally {
      setProcesando(false);
      setMensajeProcesando('');
    }
  };
  const handleChange = (e) => setAnio(parseInt(e.target.value, 10));
  return (
    <div className="cierre-mensual">
      <h1>Cierre Mensual</h1>
      <label>Año: </label>
      <select value={anio} onChange={handleChange} disabled={procesando}>
        {[2026, 2025, 2024].map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
      <table className="cierre-table">
        <thead>
          <tr>
            <th>Mes</th>
            <th>Cerrado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {meses.map((name, idx) => (
            <tr key={idx + 1}>
              <td>{name}</td>
              <td className={estado[idx + 1] ? 'status-true' : 'status-false'}>
                {estado[idx + 1] ? 'Sí' : 'No'}
              </td>
              <td>
                <button onClick={() => toggleMes(idx + 1)} disabled={procesando}>
                  {estado[idx + 1] ? 'Abrir mes' : 'Cerrar mes'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {procesando && (
        <div className="cierre-overlay">
          <div className="cierre-overlay-box">
            <div className="cierre-spinner" />
            <p>{mensajeProcesando || 'Procesando...'}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CierreMensual;